import request from '@/config/axios'

// 丢单分析 VO
export interface LostAnalysisVO {
  id: number // 编号
  customerId: number // 客户编号
  customerName?: string // 客户名称
  contactName: string // 联系人
  reasonId: number // 丢单原因概述（丢单原因分类编号）
  reasonName?: string // 丢单原因概述名称
  reasonDetail: string // 丢单原因详细说明
  projectStarted: boolean // 项目是否启动
  projectStartedName?: string // 项目是否启动（文本）
  dealPrice: string // 成交价格
  vendor: string // 选择厂商
  fileUrls: string[] // 相关文件
  solution: string // 解决方案
  submitTime: Date // 时间（提交时间）
  creator?: string
  creatorName?: string
  createTime?: Date
}

// 丢单分析 API
export const LostAnalysisApi = {
  // 查询丢单分析分页
  getLostAnalysisPage: async (params: any) => {
    return await request.get({ url: `/crm/lost-analysis/page`, params })
  },

  // 查询丢单分析详情
  getLostAnalysis: async (id: number) => {
    return await request.get({ url: `/crm/lost-analysis/get?id=` + id })
  },

  // 新增丢单分析
  createLostAnalysis: async (data: LostAnalysisVO) => {
    return await request.post({ url: `/crm/lost-analysis/create`, data })
  },

  // 修改丢单分析
  updateLostAnalysis: async (data: LostAnalysisVO) => {
    return await request.put({ url: `/crm/lost-analysis/update`, data })
  },

  // 删除丢单分析
  deleteLostAnalysis: async (id: number) => {
    return await request.delete({ url: `/crm/lost-analysis/delete?id=` + id })
  },

  // 导出丢单分析
  exportLostAnalysis: async (params: any) => {
    return await request.download({ url: `/crm/lost-analysis/export`, params })
  }
}
